
import { useSnackbar } from 'notistack'
import { useNavigate } from 'react-router-dom'
import { useForm } from '../../hooks/useForm'
import Input from '../../blocks/Input'
import './link-by-pnr.css'
import utils from '../../scripts/utils'
import { ajax } from '../../scripts/helper'


const LinkByPnrForm = ({paymentType}) => {
    const { enqueueSnackbar } = useSnackbar()

    const navigate = useNavigate()


    const [inputFields, handleChange, setInputFields] = useForm({
        pnr: {
            name: 'pnr',
            value: '',
            type: 'text',
            placeholder: 'PNR'
        }
    })


    const getDetailsByPNR = async() => {
        
        if(inputFields.pnr.value === '') return enqueueSnackbar('PNR is empty', {variant: 'error'})

        const res = await ajax({
            method: 'GET',
            hasToken: true,
            url: utils.urls.getDetailByPNR(inputFields.pnr.value),
            snackbar: enqueueSnackbar
        })

        if(!res) return

        console.log(res, 'response ')

        if(paymentType === 'link'){
            navigate('/agent/payments/single-by-pnr', {replace: true, state: {data: res.data}})
        }

        if(paymentType === 'pos'){
            navigate('/agent/payments/pos-payment', {replace: true, state: {data: res.data, type: 'pnr'}})
        }



    }


    return(
        <>
            <div className="form-container__header"> Get Payment Information By PNR</div>
            <div className="pnr-detail">
                <label>PNR</label>
                <div className="pnr-detail-container">
                    <div className="pnr-detail-input">
                        <Input inputField={inputFields.pnr} onChange={handleChange} />
                    </div>
                </div>
            <div className="pnr-btn-container">
                    <button onClick={() => {navigate('/agent/payments', {replace: true})}} className="payment-btn-back">Back</button>
                    <button onClick={()=> getDetailsByPNR()} className="payment-btn">Get Detail</button>

            </div>
            </div>
        </>
    )
}

export default LinkByPnrForm